import { render } from "./PlanSuccess.vue?vue&type=template&id=286c8f45"
import script from "./PlanSuccess.vue?vue&type=script&lang=js"
export * from "./PlanSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src439103385/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__